import React from "react";
import { Wallet } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

function fmt(n, d = 2) {
  return Number(n).toLocaleString("fr-FR", { minimumFractionDigits: d, maximumFractionDigits: d });
}

export function BudgetDeductAction({ curVal, currSymbol, isLocal, currency, eurVal, labelInput, onLabelChange, onDeduct }) {
  return (
    <div className="space-y-2 mb-5">
      <input
        className="w-full border border-[#DCD4C6] bg-white px-3 py-2.5 text-sm text-[#2B2623] placeholder-[#C8C0B8] focus:outline-none focus:border-[#C17F59] transition-colors"
        style={{ ...LORA, borderRadius: "2px" }}
        placeholder="Libellé — ex : Restaurant, Musée, Transport..."
        value={labelInput}
        onChange={(e) => onLabelChange(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && onDeduct()}
        data-testid="input-label"
      />
      <button
        onClick={onDeduct}
        disabled={curVal <= 0}
        className="w-full py-4 text-base bg-[#2B2623] text-[#F9F6F0] hover:bg-[#3D3530] disabled:opacity-40 transition-colors flex items-center justify-center gap-2.5"
        style={{ ...LORA, fontWeight: 600, borderRadius: "2px" }}
        data-testid="btn-deduct"
      >
        <Wallet size={18} strokeWidth={1.5} />
        {curVal > 0
          ? `Déduire ${fmt(curVal)} ${currSymbol}${isLocal && currency !== "EUR" ? ` (≈ ${fmt(eurVal)} €)` : ""}`
          : "Déduire du budget"}
      </button>
    </div>
  );
}
